import { useState, useEffect } from 'react';
import { apiFetch } from '../lib/apiClient';
import type { CountryResource, ProductsResponse } from '../types/api';

let cache: CountryResource[] | null = null;
let inflight: Promise<CountryResource[]> | null = null;

export function useProducts() {
  const [data, setData] = useState<CountryResource[] | null>(cache);
  const [loading, setLoading] = useState(!cache);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (cache) return;
    if (!inflight) {
      inflight = apiFetch<ProductsResponse>('/v1/products')
        .then(r => {
          cache = r.data;
          return r.data;
        })
        .finally(() => {
          inflight = null;
        });
    }
    inflight
      .then(d => { setData(d); setLoading(false); })
      .catch(e => { setError((e as Error).message); setLoading(false); });
  }, []);

  return { data, loading, error };
}
